// extracted by mini-css-extract-plugin
export var divider = "_mq-0";
export var systemMessage = "_mq-1";
export var systemMessageWrapper = "_mq-2";